<template>
	<div>
		<v-btn icon small color="primary">
			<v-icon small>mdi-download</v-icon>
		</v-btn>
		<v-btn icon small color="primary">
			<v-icon small>mdi-share-variant</v-icon>
		</v-btn>
	</div>
</template>

<script>
	export default{
		name: "ResultsButtons"
	}
</script>